<template>
  <el-dialog
    v-model="visible"
    id="dialog"
    :width="dialogWidth"
    title=" ثبت برنامه جدید"
    :before-close="handleClose"
    class="dialog-container"
  >
    <!-- <div class="day-selection">
      <el-button
        v-for="day in days"
        :key="day.key"
        :type="selectedDay === day.key ? 'primary' : 'default'"
        @click="selectedDay = day.key"
        size="small"
        :disabled="loading"
        class="day-button"
      >
        {{ day.name }}
      </el-button>
    </div>-->
    <div class="week-dots">
      <div
        v-for="day in days"
        :key="day.key"
        @click="selectedDay = day.key"
        :class="['day-dot', { active: selectedDay === day.key }]"
        :title="day.name"
        :disabled="loading"
      >
        {{ day.name }}
      </div>
    </div>
    <div class="time-inputs">
      <!-- Start Time -->
      <div class="time-group">
        <div class="time-row">
         
          <div class="time-item">
            <label class="time-label">دقیقه شروع</label>
            <el-input-number
              v-model="startMinute"
              :min="0"
              :max="59"
              :disabled="loading"
              controls-position="right"
            />
          </div>
           <div class="time-item margin-right-clock" >
            <label class="time-label">ساعت شروع</label>
            <el-input-number
              v-model="startHour"
              :min="0"
              :max="23"
              :disabled="loading"
              controls-position="right"
            />
          </div>
        </div>
      </div>

      <!-- End Time -->
      <div class="time-group">
        <div class="time-row">
         
          <div class="time-item">
            <label class="time-label">دقیقه پایان</label>
            <el-input-number
              v-model="endMinute"
              :min="0"
              :max="59"
              :disabled="loading"
              controls-position="right"
            />
          </div>
           <div class="time-item margin-right-clock">
            <label class="time-label">ساعت پایان</label>
            <el-input-number
              v-model="endHour"
              :min="0"
              :max="23"
              :disabled="loading"
              controls-position="right"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      style="text-align: center; color: red; margin-top: 12px"
      v-html="resultMessage"
    ></div>

    <template #footer>
      <div style="display: flex; justify-content: center; width: 100%">
        <el-button :disabled="loading" @click="handleCancel">انصراف</el-button>
        <el-button type="primary" :disabled="loading" @click="handleConfirm">
          تایید
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  ref,
  computed,
  onUnmounted,
  defineProps,
  defineEmits,
  onMounted,
} from "vue";
import { ElLoading } from "element-plus";
import socket from "@/services/socket";

const loading = ref(false);
const selectedDay = ref(null);
const localProgramList = ref([]);
let timeout = null;
const startHour = ref(14);
const startMinute = ref(30);
const endHour = ref(15);
const endMinute = ref(30);
const dialogWidth = ref("400px");
const resultMessage = ref(null);
const days = [
  { name: "شنبه", key: 6 },
  { name: "یکشنبه", key: 0 },
  { name: "دوشنبه", key: 1 },
  { name: "سه‌شنبه", key: 2 },
  { name: "چهارشنبه", key: 3 },
  { name: "پنج‌شنبه", key: 4 },
  { name: "جمعه", key: 5 },
];

const props = defineProps({
  modelValue: Boolean,
  programList: Array,
  activeDevice: Array,
});
const emit = defineEmits(["update:modelValue", "confirmed"]); //"updateProgramList"

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

let timeoutId = null;
let loadingInstance = null;
/*
const formatTime = (val) =>
  val !== null && val !== undefined ? String(val).padStart(2, "0") : "";
const parseTime = (val) =>
  val ? String(parseInt(val, 10)).padStart(2, "0") : "00";
*/
/*function handleInput(field, val) {
  let numeric = String(val).replace(/\D/g, "");

  // حد مجاز برای هر فیلد
  const limits = {
    startMinute: 59,
    endMinute: 59,
    startHour: 23,
    endHour: 23,
  };

  let max = limits[field];
  let num = parseInt(numeric);

  if (isNaN(num)) {
    if (field === "startMinute") startMinute.value = "";
    else if (field === "endMinute") endMinute.value = "";
    else if (field === "startHour") startHour.value = "";
    else if (field === "endHour") endHour.value = "";
  } else if (num > max) {
    if (field === "startMinute") startMinute.value = max.toString();
    else if (field === "endMinute") endMinute.value = max.toString();
    else if (field === "startHour") startHour.value = max.toString();
    else if (field === "endHour") endHour.value = max.toString();
  } else {
    if (field === "startMinute") startMinute.value = numeric;
    else if (field === "endMinute") endMinute.value = numeric;
    else if (field === "startHour") startHour.value = numeric;
    else if (field === "endHour") endHour.value = numeric;
  }
}*/

function validationData() {
  resultMessage.value = "";
  let validation = true;
  const start = startHour.value * 60 + startMinute.value;
  const end = endHour.value * 60 + endMinute.value;

  if (selectedDay.value == null) {
    validation = false;
    resultMessage.value =
      '<b style="color:red;">    لطفا یکی از روزهای هفته را انتخاب نمایید   </b>';
  }
  // فقط وقتی پایان بزرگ‌تر از شروع باشد مجاز است
  if (end <= start) {
    resultMessage.value +=
      '<br><b style="color:red;">ساعت شروع باید از ساعت پایان کوچکتر باشد</b>';
    validation = false;
  }

  if (!validation) return;
  const dayPeriods = props.programList[0][selectedDay.value]?.periods || [];
  localProgramList.value = JSON.parse(JSON.stringify(dayPeriods));

  validation = !hasConflict();
  return validation;
}
function hasConflict() {
  const toMinutes = (time) => {
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
  };

  const newStartMin = startHour.value * 60 + startMinute.value;
  const newEndMin = endHour.value * 60 + endMinute.value;

  for (const period of localProgramList.value) {
    const existingStart = toMinutes(period.startTime);
    const existingEnd = toMinutes(period.endTime);

    const isOverlapping = !(
      newEndMin <= existingStart || newStartMin >= existingEnd
    );
    if (isOverlapping) {
      resultMessage.value +=
        '<b style="color:red;"> تداخل با ساعت ثبت شده قبلی </b>';
      return true;
    }
  }

  return false;
}
/*
function addPeriod() {
  localProgramList.value.push({
    id: 0,
    startTime: startHour.value + ":" + startMinute.value,
    endTime: endHour.value + ":" + endMinute.value,
    userLocalID: props.userLocalID.value,
  });
  const updatedList = JSON.parse(JSON.stringify(props.programList));
  updatedList[0][selectedDay.value].periods = [...localProgramList.value];
  emit("update:programList", updatedList);
}*/

function handleConfirm() {
  if (props.activeDevice.user_local_id == null) {
    resultMessage.value =
      "امکان ثبت برنامه بدون اثر انگشت ممکن نیست، لطفا به ثبت اثر انگشت اقدام فرمایید";
    return;
  }
  if (loading.value) return;
  resultMessage.value = "";
  if (!validationData()) return;
  const start =
    String(startHour.value).padStart(2, "0") +
    ":" +
    String(startMinute.value).padStart(2, "0");

  const end =
    String(endHour.value).padStart(2, "0") +
    ":" +
    String(endMinute.value).padStart(2, "0");
  const sendData = {
    deviceID: props.activeDevice.device_id,
    pin: props.activeDevice.pin,
    code: props.activeDevice.code,
    userLocalID: props.activeDevice.user_local_id,
    weekDay: selectedDay.value,
    startTime: start,
    endTime: end,
  };
  socket.emit("program/add", sendData);

  loading.value = true;
  loadingInstance = ElLoading.service({
    lock: true,
    text: "لطفا صبر کنید...",
    background: "rgba(0, 0, 0, 0.3)",
    body: true,
    fullscreen: true,
    spinnerSize: "60px",
    customClass: "my-loading-custom",
  });

  timeout = setTimeout(() => {
    resultMessage.value = "متاسفانه پاسخی از سمت دستگاه دریافت نشد.";
    loading.value = false;
    loadingInstance?.close();
  }, 40000);

  socket.once("program/add", (data) => {
    clearTimeout(timeout);
    if (data.status == 2) {
      resultMessage.value = "متاسفانه پاسخی از سمت دستگاه دریافت نشد.";
      loading.value = false;
      loadingInstance?.close();
      return;
    }
    loading.value = false;
    visible.value = false;
    loadingInstance?.close();
    //addPeriod()
    resultMessage.value = "";
    emit("confirmed", {
      weekDay: sendData.weekDay,
      start: start,
      end: end,
      userLocalID: sendData.userLocalID,
      code: sendData.code,
    }); // <=== این خط اضافه کن
  });
}
const updateDialogWidth = () => {
  dialogWidth.value = window.innerWidth <= 600 ? "98%" : "400px";
};
onMounted(() => {
  updateDialogWidth();
  window.addEventListener("resize", updateDialogWidth);
});
function handleCancel() {
  if (!loading.value) {
    visible.value = false;
    resultMessage.value = "";
  }
}

function handleClose(done) {
  if (!loading.value) done();
}

onUnmounted(() => {
  if (timeoutId) clearTimeout(timeoutId);
  loadingInstance?.close();
});
</script>

<style scoped>
.dialog-container {
  direction: rtl;
}

.day-selection {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 30px;
  justify-content: center;
}

.day-button {
  min-width: 70px;
  font-size: 13px;
}
.margin-right-clock{
  margin-right: 5px!important;
}
.time-inputs {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
}

.time-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.time-row {
  display: flex;
  gap: 8px;
}

.el-dialog__footer button {
  margin: 10px;
  width: 100px;
}
@media (max-width: 600px) {
  .time-inputs {
    flex-direction: column;
    align-items: center;
  }
}
.time-row {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.time-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.time-label {
  font-size: 12px;
  margin-bottom: 4px;
  color: #606266;
}

.week-dots {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
}

.day-dot {
  /*padding: 2px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.6rem;
  border: 1px solid #919eab;
  min-width: 40px;
  font-weight: 600;*/
  width: 60px;
  min-width: 33px;
  height: 30px;
  padding: 2px;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-size: 0.7rem;
  font-weight: 600;
  position: relative;
  border: 2px solid #e0e0e0;
  color: #555;
}

.day-dot:hover {
  background: #265d8d;
  color: white;
  border: unset;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.2);
  transform: translateY(-2px);
}

.day-dot.active {
  background: #205685;
  color: white;

  color: white;
  border: unset;
  box-shadow: 0 4px 12px rgba(33, 115, 221, 0.3);
  transform: translateY(-2px);
}
.day-dot.active::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 3px;
  background: #124b7a;
  border-radius: 3px;
}
@media (max-width: 400px) {
  .day-dot {
    font-size: 0.6rem;
    height: 25px;
  }
}
.el-button--primary {
  color: white;
  background-color: #0c62b3;
}
::v-deep(.my-loading-custom .el-loading-text) {
  color: #0c62b3 !important;
  font-weight: 700;
}
::v-deep(.my-loading-custom .el-loading-spinner) {
  width: 60px;
  height: 60px;
}
</style>
